import Dashboard from "../../../components/pages/residential/dashboard/Dashboard";
import SiteList from "../../../components/pages/residential/MasterManagement/Site/SiteList";
import SiteForm from "../../../components/pages/residential/MasterManagement/Site/SiteForm";
import WingList from "../../../components/pages/residential/MasterManagement/Wing/WingList";
import WingForm from "../../../components/pages/residential/MasterManagement/Wing/WingForm";
import FloorList from "../../../components/pages/residential/MasterManagement/Floor/FloorList";
import FloorForm from "../../../components/pages/residential/MasterManagement/Floor/FloorForm";
import UnitList from "../../../components/pages/residential/MasterManagement/Unit/UnitList";
import UnitForm from "../../../components/pages/residential/MasterManagement/Unit/UnitForm";
import RoleList from "../../../components/pages/residential/MasterManagement/Role/RoleList";
import RoleForm from "../../../components/pages/residential/MasterManagement/Role/RoleForm";
import AmenitiesTypeList from "../../../components/pages/residential/MasterManagement/AmenitiesType/AmenitiesTypeList";
import AmenitiesTypeForm from "../../../components/pages/residential/MasterManagement/AmenitiesType/AmenitiesTypeForm";
import UserList from "../../../components/pages/residential/UserManagement/User/UserList";
import UserForm from "../../../components/pages/residential/UserManagement/User/UserForm";
import VisitorList from "../../../components/pages/residential/VisitorManagement/VisitorList";
import VisitorForm from "../../../components/pages/residential/VisitorManagement/VisitorForm";
import StaffList from "../../../components/pages/residential/StaffManagement/StaffList";
import StaffForm from "../../../components/pages/residential/StaffManagement/StaffForm";
import NewsList from "../../../components/pages/residential/NewsLetters/NewsList";
import NewsLettersMain from "../../../components/pages/residential/NewsLetters/NewsLettersMain";
import NewsForm from "../../../components/pages/residential/NewsLetters/NewsForm";
import Notices from "../../../components/pages/residential/Notices/Notices";
import NoticeForm from "../../../components/pages/residential/Notices/NoticeForm";
import PollList from "../../../components/pages/residential/PollManagement/PollList";
import PollForm from "../../../components/pages/residential/PollManagement/PollForm";
import AmenitiesList from "../../../components/pages/residential/AmenitiesManagement/AmenitiesList";
import AmenitiesForm from "../../../components/pages/residential/AmenitiesManagement/AmenitiesForm";
import AmenitiesBooking from "../../../components/pages/residential/AmenitiesManagement/AmenitiesBooking";
import ComplaintList from "../../../components/pages/residential/Complaint/ComplaintList";
import ComplaintForm from "../../../components/pages/residential/Complaint/ComplaintForm";
import VehicleType from "../../../components/pages/residential/ParkingManagement/VehicleType";
import ParkingSlotList from "../../../components/pages/residential/ParkingManagement/ParkingSlotList";
import ParkingSlotForm from "../../../components/pages/residential/ParkingManagement/ParkingSlotForm";
import VisitorReports from "../../../components/pages/commercial/VisitorsManagment/Reports/VisitorReports";
import ChatApp from "../../../components/pages/residential/Chat/ChatApp";

export const residentialRoutes = [
  {
    path: "dashboard",
    element: <Dashboard />,
    breadcrumbs: ["Dashboard"],
  },
  {
    path: "Master-management/site",
    element: <SiteList />,
    breadcrumbs: ["Master Management", "Site List"],
  },
  {
    path: "Master-management/site/form",
    element: <SiteForm />,
    breadcrumbs: ["Master Management", "Site List", "Site Form"],
  },
  {
    path: "Master-management/Wings",
    element: <WingList />,
    breadcrumbs: ["Master Management", "Wing List"],
  },
  {
    path: "Master-management/Wings/form",
    element: <WingForm />,
    breadcrumbs: ["Master Management", "Wing List", "Wing Form"],
  },
  {
    path: "Master-management/floor",
    element: <FloorList />,
    breadcrumbs: ["Master Management", "Floor List"],
  },
  {
    path: "Master-management/floor/form",
    element: <FloorForm />,
    breadcrumbs: ["Master Management", "Floor List", "Floor Form"],
  },
  {
    path: "Master-management/unit",
    element: <UnitList />,
    breadcrumbs: ["Master Management", "Unit List"],
  },
  {
    path: "Master-management/unit/form",
    element: <UnitForm />,
    breadcrumbs: ["Master Management", "Unit List", "Unit Form"],
  },
  {
    path: "Master-management/role",
    element: <RoleList />,
    breadcrumbs: ["Master Management", "Role List"],
  },
  {
    path: "Master-management/role/form",
    element: <RoleForm />,
    breadcrumbs: ["Master Management", "Role List", "Role Form"],
  },
  {
    path: "Master-management/AmenitiesType",
    element: <AmenitiesTypeList />,
    breadcrumbs: ["Master Management", "Amenities Type List"],
  },
  {
    path: "Master-management/AmenitiesType/form",
    element: <AmenitiesTypeForm />,
    breadcrumbs: ["Master Management", "Amenities Type List", "Add Amenity Type"],
  },
  {
    path: "Master-management/AmenitiesType/form/:id",
    element: <AmenitiesTypeForm />,
    breadcrumbs: ["Master Management", "Amenities Type List", "Edit Amenity Type"],
  },
  {
    path: "Family-management/Family-list",
    element: <UserList />,
    breadcrumbs: ["Family Management", "Family List"],
  },
  {
    path: "Family-management/familyform/add",
    element: <UserForm />,
    breadcrumbs: ["Family Management", "Family List", "Add Family"],
  },
  {
    path: "Family-management/familyform/:id",
    element: <UserForm />,
    breadcrumbs: ["Family Management", "Family List", "Edit Family"],
  },
  {
    path: "report/visitor-report",
    element: <VisitorReports />,
    breadcrumbs: ["Report", "Visitor Report"],
  },
  {
    path: "visitor-management/visitor",
    element: <VisitorList />,
    breadcrumbs: ["Visitor Management", "Visitor List"],
  },
  {
    path: "visitor-management/visitor-form",
    element: <VisitorForm />,
    breadcrumbs: ["Visitor Management", "Visitor List", "Visitor Form"],
  },
  {
    path: "visitor-management/visitor-form/add",
    element: <VisitorForm />,
    breadcrumbs: ["Visitor Management", "Visitor List", "Add Visitor"],
  },
  {
    path: "visitor-management/visitor-form/:id",
    element: <VisitorForm />,
    breadcrumbs: ["Visitor Management", "Visitor List", "Edit Visitor"],
  },
  {
    path: "Staff-management/Staff-list",
    element: <StaffList />,
    breadcrumbs: ["Staff Management", "Staff List"],
  },
  {
    path: "Staff-management/staff-Form",
    element: <StaffForm />,
    breadcrumbs: ["Staff Management", "Staff List", "Staff Form"],
  },
  {
    path: "Staff-management/staff-Form/add",
    element: <StaffForm />,
    breadcrumbs: ["Staff Management", "Staff List", "Add Staff"],
  },
  {
    path: "Staff-management/staff-Form/:mobile",
    element: <StaffForm />,
    breadcrumbs: ["Staff Management", "Staff List", "Edit Staff"],
  },
  {
    path: "News-Letters",
    element: <NewsLettersMain />,
    breadcrumbs: ["News Letters", "News List"],
  },
  {
    path: "News-Letters/Notice/add",
    element: <NoticeForm />,
    breadcrumbs: ["News Letters", "News List", "Add Notice"],
  },
  {
    path: "News-Letters/Notice/edit/:id",
    element: <NoticeForm />,
    breadcrumbs: ["News Letters", "News List", "Edit Notice"],
  },
  {
    path: "News-Letters/add",
    element: <NewsForm />,
    breadcrumbs: ["News Letters", "News List", "Add News"],
  },
  {
    path: "News-Letters/edit/:id",
    element: <NewsForm />,
    breadcrumbs: ["News Letters", "News List", "Edit News"],
  },
  {
    path: "Notices",
    element: <Notices />,
    breadcrumbs: ["Notices"],
  },
  {
    path: "Poll-Management",
    element: <PollList />,
    breadcrumbs: ["Poll Management", "Poll List"],
  },
  {
    path: "Poll-Management/poll-list",
    element: <PollList />,
    breadcrumbs: ["Poll Management", "Poll List"],
  },
  {
    path: "Poll-Management/poll-form/add",
    element: <PollForm />,
    breadcrumbs: ["Poll Management", "Poll List", "Add Poll"],
  },
  {
    path: "Poll-Management/poll-form/:id",
    element: <PollForm />,
    breadcrumbs: ["Poll Management", "Poll List", "Edit Poll"],
  },
  {
    path: "Amenities-Management",
    element: <AmenitiesList />,
    breadcrumbs: ["Amenities Management", "Amenities List"],
  },
  {
    path: "Amenities-Management/Amenities-list",
    element: <AmenitiesList />,
    breadcrumbs: ["Amenities Management", "Amenities List"],
  },
  {
    path: "Amenities-Management/Amenities-form/add",
    element: <AmenitiesForm />,
    breadcrumbs: ["Amenities Management", "Amenities List", "Add Amenity"],
  },
  {
    path: "Amenities-Management/Amenities-form/:id",
    element: <AmenitiesForm />,
    breadcrumbs: ["Amenities Management", "Amenities List", "Edit Amenity"],
  },
  {
    path: "Amenities-Management/Amenities-form/:id/edit",
    element: <AmenitiesForm />,
    breadcrumbs: ["Amenities Management", "Amenities List", "Edit Amenity"],
  },
  {
    path: "Amenities-Management/Amenities-Booking",
    element: <AmenitiesBooking />,
    breadcrumbs: ["Amenities Management", "Amenities List", "Bookings"],
  },
  {
    path: "ComplaintList",
    element: <ComplaintList />,
    breadcrumbs: ["Helpdesk", "Complaint List"],
  },
  {
    path: "Complaint/ComplaintList",
    element: <ComplaintList />,
    breadcrumbs: ["Helpdesk", "Complaint List"],
  },
  {
    path: "ComplaintList/add",
    element: <ComplaintForm />,
    breadcrumbs: ["Helpdesk", "Complaint List", "Raise Complaint"],
  },
  {
    path: "Complaint/ComplaintList/add",
    element: <ComplaintForm />,
    breadcrumbs: ["Helpdesk", "Complaint List", "Raise Complaint"],
  },
  {
    path: "ComplaintList/edit/:id",
    element: <ComplaintForm />,
    breadcrumbs: ["Helpdesk", "Complaint List", "Edit Complaint"],
  },
  {
    path: "Complaint/ComplaintList/edit/:id",
    element: <ComplaintForm />,
    breadcrumbs: ["Helpdesk", "Complaint List", "Edit Complaint"],
  },
  {
    path: "parking-management/vehicle-Type",
    element: <VehicleType />,
    breadcrumbs: ["Parking Management", "Vehicle Types"],
  },
  {
    path: "parking-management/parking-slot",
    element: <ParkingSlotList />,
    breadcrumbs: ["Parking Management", "Parking Slots"],
  },
  {
    path: "parking-management/parking-slot/add",
    element: <ParkingSlotForm />,
    breadcrumbs: ["Parking Management", "Parking Slots", "Add Slot"],
  },
  {
    path: "parking-management/parking-slot/:action/:id",
    element: <ParkingSlotForm />,
    breadcrumbs: ["Parking Management", "Parking Slots", "Edit Slot"],
  },
  {
    path: "Chat/GroupList",
    element: <ChatApp />,
    breadcrumbs: ["Chat & Groups", "Chat"],
  }
];
